<template>
  <div class="editCostumerRelation">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{$t('LanguageLib.COSTUMER_RELATION_INFO')}}</span>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave">
          {{$t('LanguageLib.SAVE')}}
        </el-button>
        <p class="drawerText"><span class="colorRed">*</span>{{$t('LanguageLib.COSTUMER_CODE')}}</p>
        <el-form-item prop="costumerCode">
          <el-input
            hide-required-asterisk
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            :maxlength="50"
            v-model="ruleForm.costumerCode"
          ></el-input>
        </el-form-item>

        <p class="drawerText"><span class="colorRed">*</span>{{$t('LanguageLib.COSTUMER_NAME')}}</p>
        <el-form-item prop="costumerName">
          <el-input
            hide-required-asterisk
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            :maxlength="50"
            v-model="ruleForm.costumerName"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
// import NProgress from 'nprogress'
import basicdataApi from '../../api/basicdata'

export default {
  mounted () {
    const query = this.$route.query
    this.ruleForm.costumerName = query.costumerName
    this.ruleForm.costumerCode = query.costumerCode
    this.ruleForm.id = query.id

    console.log(this.ruleForm)
    this.type = query.type
  },
  name: 'EditCostumerRelation',
  components: {},
  props: [],
  data () {
    var checkCostumerName = (rule, value, callback) => {
      console.log('$$$$$$')
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.COSTUMER_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.COSTUMER_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkCostumerCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.COSTUMER_CODE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.COSTUMER_CODE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      type: '', // edit or add
      loadingSave: false,
      queryData: {},
      ruleForm: {
        id: '',
        costumerCode: '',
        costumerName: ''
      },
      rules: {
        costumerName: [
          { validator: checkCostumerName, trigger: 'blur' }
        ],
        costumerCode: [
          { validator: checkCostumerCode, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    goReturn () {
      this.$router.push('/basicdata/costumerrelation')
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type) {
            // 识别模式
            const type = this.type
            if (type === 'add') {
              const para = {
                Code: this.ruleForm.costumerCode,
                Name: this.ruleForm.costumerName
              }
              basicdataApi.addCostumerRelation('post', '/supplier/add', para).then(
                res => {
                  this.$router.push('/basicdata/costumerrelation')
                }
              ).catch(err => {
                this.$commonfun.console.log(err)
              })
            } else if (type === 'edit') {
              const para = {
                id: this.ruleForm.id,
                code: this.ruleForm.costumerCode,
                name: this.ruleForm.costumerName
              }
              console.log(para)
              basicdataApi.updateCostumerRelation('post', '/supplier/update', para).then(
                res => {
                  this.$router.push('/basicdata/costumerrelation')
                }
              ).catch(err => {
                this.$commonfun.console.log(err)
              })
            }
          }
        }
      })
    }
  },
  computed: {}
}
</script>

<style lang="scss">
  .editCostumerRelation {
    height: 100%;
    width: 100%;
    .colorRed{
      color: red;
    }
    .left {
      background: #fff;
      width: 320px;
      float: left;
      height: 100%;
      border-right: 1px solid #f2f2f2;

      .treeBox {
        height: 485px;
      }
    }

    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }

    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;

      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }

      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }

      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }

    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }

    .content {
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc(100% - 50px);
      overflow-y: auto;
      padding-left: 100px;
      padding-top: 15px;

      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }
    }

    // 修改按钮样式
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }

    .colorRed {
      color: red;
    }

    // 组织树视图
    .el-dialog {
      overflow: hidden;
    }

    .el-textarea__inner {
      font: 400 14px Arial;
    }

    .el-input .is-disabled {
      color: #2c3e50;
    }
  }
</style>
